import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_NOPHAITHU } from "actions/NoPhaiThu/actionTypes";
import {
  getListNoPhaiThuSuccess,
  getListNoPhaiThuFailure,
} from "actions/NoPhaiThu";
import NoPhaiThuApi from "service/noPhaiThuApi";
import { pushNotification } from "utils/notifications";

function* getListNoPhaiThu(action) {
  try {
    const response = yield call(NoPhaiThuApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListNoPhaiThuSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListNoPhaiThuFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListNoPhaiThuFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_NOPHAITHU, getListNoPhaiThu);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
